import axios from "../plugins/axios";

const apiUrl = process.env.REACT_APP_WORKNEST_TOOLS_API_URL;

export interface AccountFile {
    title: string;
    subtitle?: string;
    uri: string;
}

export interface AccountFileFolder {
    title: string;
    children: AccountFile[];
}

const fetchAccountFiles = async (
    accountId: number | string | undefined,
    fileType: number,
    documentType: number,
): Promise<AccountFileFolder[]> => {
    try {
        const response = await axios.get<AccountFileFolder[]>(
            `${apiUrl}/getaccountfiles/${accountId}/${fileType}/${documentType}`,
        );
        return response.data;
    } catch (e: any) {
        console.error(e);
        return Promise.reject(e?.message || "Could not fetch documents.");
    }
};

const getAnswers = async (externalId: string): Promise<unknown> => {
    try {
        const response = await axios.get(`${apiUrl}/gettemplateanswers/${externalId}`);
        return response.data;
    } catch (e: any) {
        console.error(e);
        return Promise.reject(e?.message || "Could not fetch answers.");
    }
};

const saveAnswers = async (externalId: string, answers: unknown): Promise<void> => {
    try {
        await axios.post(`${apiUrl}/savetemplateanswers/${externalId}`, answers);
    } catch (e: any) {
        console.error(e);
        return Promise.reject(e?.message || "Could not save answers.");
    }
};

const fetchManualAndHandbookFiles = async (accountId: number | string): Promise<unknown> => {
    try {
        const response = await axios.get(`${apiUrl}/getmanualandhandbookitems/${accountId}/`);
        return response.data;
    } catch (e: any) {
        console.error(e);
        return Promise.reject(e?.message || "Could not fetch documents.");
    }
};

const uploadAccountFile = async (
    formData: FormData,
    accountId: number | string,
    fileType: number,
    documentType: number,
): Promise<unknown> => {
    const response = await axios.post(
        `${apiUrl}/adddocument/${documentType}/${fileType}/?accountId=${accountId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

const deleteAccountFile = async (
    formData: FormData,
    documentType: number,
): Promise<unknown> => {
    try {
        const response = await axios.post(`${apiUrl}/deleteDocument/${documentType}`, formData);
        return response.data;
    } catch (e: any) {
        console.error(e);
        return Promise.reject(e?.message || "Could not delete Account File.");
    }
};

const updateAccountFile = async (
    formData: FormData,
    documentType: number,
): Promise<unknown> => {
    try {
        const response = await axios.post(`${apiUrl}/updateDocument/${documentType}`, formData);
        return response.data;
    } catch (e: any) {
        console.error(e);
        return Promise.reject(e?.message || "Could not update Account File.");
    }
};

const documentService = {
    fetchAccountFiles,
    uploadAccountFile,
    deleteAccountFile,
    updateAccountFile,
    fetchManualAndHandbookFiles,
    getAnswers,
    saveAnswers,
};

export default documentService;
